import React from 'react';

/**
 * Renders the preloader
 */
const SmallLoader = () => (
    // <div className="preloader text-center">
    //     <div className="status">
    //         <div className="spinner-border avatar-sm text-primary m-2" role="status"></div>
    //     </div>
    // </div>
    <div style={{display: "flex", alignItems: "center", justifyContent: "center",}}>
        <div style={{  textAlign: "center", marginTop: "10px", marginBottom: "10px",}} >
            <svg  width="45" height="45"  viewBox="0 0 50 50" style={{ display: "block" }}>
                <circle cx="25" cy="25" r="20" fill="none" stroke="#fff" strokeWidth="5" strokeLinecap="round" strokeDasharray="31.415, 31.415">
                    <animateTransform attributeName="transform"  type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
                </circle>
            </svg>
        </div>
    </div>
);

export default SmallLoader;
